const sec3_cont = document.getElementById("ab-sec3-cont");
// const logo_img= docunent.getElementById("ab-logo-cont-img");


let isAnimated_sec3 = false;

window.addEventListener("scroll", () => {

    const sec3_cont_top = sec3_cont.getBoundingClientRect().top;

    if(sec3_cont_top <= 500 && !isAnimated_sec3){
        // logo_img.style.transform = "rotateY(180deg)";
        animateTextSec3();
        isAnimated_sec3 = true;
    }
});

function animateTextSec3(){

    const text_h1 = document.getElementById("ab-text-h1");

    text_h1.innerHTML = wrapTextInSpanSec3("WHAT'S BEHIND EVERY BITE OF MALLINAS?");
}

function wrapTextInSpanSec3(textSec3) {
  let letterDelaySec3 = 0;
  let stepDelaySec3 = 0.03;
  return textSec3
    .split('')
    .map(char => {
      
      console.log(letterDelaySec3);
      const safeCharSec3 = char === ' ' ? '&nbsp;' : char;
      const spanSec3 = `<span style="animation-delay: ${letterDelaySec3.toFixed(1)}s">${char}</span>`;
      letterDelaySec3 = letterDelaySec3 + stepDelaySec3;
      return spanSec3;
    })
    .join('');
}